import React from 'react';
import { Flex, Box, Toast, theme } from '@xometry/xometry_loft';
import { css } from '@emotion/react';

export interface Props {
  isSuccessful: boolean;
  setIsSuccessful: (openState: boolean) => void;
  message: string;
}

export const SuccessToast = (props: Props) => {
  const { isSuccessful, setIsSuccessful, message } = props;
  return (
    <Toast
      css={css`
        position: absolute;
        top: 47px;
        left: calc(100vw / 2 - 175px);
      `}
      kind="success"
      isOpen={isSuccessful}
      onClose={() => setIsSuccessful(false)}
    >
      <Flex alignItems="center" color={theme.colors.darkBlues[50]}>
        <i className="fa fa-check-circle" />
        <Box marginLeft={theme.space[2]}>{message}</Box>
      </Flex>
    </Toast>
  );
};

export const SuccessToastQuotePresets = (props: Props) => {
  const { isSuccessful, setIsSuccessful, message } = props;
  return (
    <Toast
      kind="success"
      isOpen={isSuccessful}
      onClose={() => setIsSuccessful(false)}
    >
      <Flex alignItems="center" color={theme.colors.darkBlues[100]}>
        <i className="fa-regular fa-circle-check" />
        <Box marginLeft={theme.space[2]}>{message}</Box>
      </Flex>
    </Toast>
  );
};
